module.exports = __webpack_public_path__ + "static/media/icono_bailarin.5c03fc6d.svg";